export default __webpack_public_path__ + "static/Standard-Reports-1fdc77dd60043f5bac6a197a31a2ddbd.png";